// extracted by mini-css-extract-plugin
export var closeButton = "_hi-1";
export var closeX = "_hi-3";
export var container = "_hi-0";
export var image = "_hi-2";